import cn from 'classnames'
import React from 'react'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'

interface LabelLinkProps {
  label: string
  href: string
  className?: string
  target?: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

/**
 * Primary UI component for user interaction
 */
export const LabelLink: React.FC<LabelLinkProps> = ({ label, href, className = '', target = '', onClick }) => {
  return (
    <CompatibleLink href={href} target={target} className={cn(className, 'cursor-pointer')} onClick={onClick}>
      {label}
    </CompatibleLink>
  )
}
